/**
 * API配置文件
 * 统一管理后端接口地址和API路径
 */

// 后端服务器基础地址
export const BASE_URL = 'https://web.bzkkj.com';
// export const BASE_URL = 'http://192.168.0.52:2260';

// API接口路径
export const API = {
  // 轮播图相关接口
  BANNER: '/api/banner_api',
  
  // 药品相关接口
  MEDICINE: '/api/medicine',
  
  // 药品详情接口
  MEDICINE_DETAIL: '/api/medicine/detail',
  
  // 公司简介接口
  ABOUT_US: '/api/about_us_api',
  
  // 药品分类接口
  MEDICINE_CATEGORY: '/api/medicine_category',
  
  // 文章接口
  ARTICLE: '/api/article',
  
  // 药品搜索接口
  MEDICINE_SEARCH: '/api/medicine/index',
  
  // 底部信息接口
  FOOTER_INFO: '/api/footer_api',
  
  // 用户注册接口
  USER_REGISTER: '/api/user/register',
  
  // 用户登录接口
  USER_LOGIN: '/api/user/login',
  
  // 用户信息接口
  USER_INFO: '/api/user/index',
  
  // 用户权限药品接口
  MEDICINE_PERMITTED: '/api/medicine/permitted',
  
  // 后续可以添加其他接口
  // PRODUCTS: '/api/products',
  // NEWS: '/api/news',
  // ...
};

// 完整的API URL
export const API_URL = {
  BANNER: `${BASE_URL}${API.BANNER}`,
  MEDICINE: `${BASE_URL}${API.MEDICINE}`,
  MEDICINE_DETAIL: `${BASE_URL}${API.MEDICINE_DETAIL}`,
  ABOUT_US: `${BASE_URL}${API.ABOUT_US}`,
  MEDICINE_CATEGORY: `${BASE_URL}${API.MEDICINE_CATEGORY}`,
  ARTICLE: `${BASE_URL}${API.ARTICLE}`,
  MEDICINE_SEARCH: `${BASE_URL}${API.MEDICINE_SEARCH}`,
  FOOTER_INFO: `${BASE_URL}${API.FOOTER_INFO}`,
  USER_REGISTER: `${BASE_URL}${API.USER_REGISTER}`,
  USER_LOGIN: `${BASE_URL}${API.USER_LOGIN}`,
  USER_INFO: `${BASE_URL}${API.USER_INFO}`,
  MEDICINE_PERMITTED: `${BASE_URL}${API.MEDICINE_PERMITTED}`,
};

/**
 * 获取药品列表
 * @param {Object} params - 请求参数
 * @param {number} [params.category_id] - 按分类ID筛选药品（可选）
 * @param {string} [params.keywords] - 搜索关键词，可搜索药品名称、生产厂家或批准文号（可选）
 * @param {number} [params.page=1] - 页码，默认为1
 * @param {number} [params.pagesize=15] - 每页显示数量，默认为15
 * @returns {Promise} 返回API响应
 */
export const getMedicines = async (params = {}) => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE, { params });
    return response.data;
  } catch (error) {
    console.error('获取药品列表失败:', error);
    throw error;
  }
};

/**
 * 根据分类获取药品
 * @param {number} categoryId - 分类ID
 * @param {number} page - 页码
 * @param {number} pageSize - 每页数量
 * @returns {Promise} 返回API响应
 */
export const getMedicinesByCategory = async (categoryId, page = 1, pageSize = 15) => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE, {
      params: {
        category_id: categoryId,
        page,
        pagesize: pageSize
      }
    });
    return response.data;
  } catch (error) {
    console.error('获取分类药品失败:', error);
    throw error;
  }
};

/**
 * 搜索药品
 * @param {string} keywords - 搜索关键词
 * @param {number} [page=1] - 页码
 * @param {number} [pagesize=10] - 每页数量
 * @returns {Promise} 返回API响应
 */
export const searchMedicineAPI = async (keywords, page = 1, pagesize = 10) => {
  if (!keywords) {
    return {
      code: 0,
      msg: '请输入搜索关键词',
      time: String(Math.floor(Date.now() / 1000))
    };
  }
  
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE_SEARCH, {
      params: {
        keywords,
        page,
        pagesize
      }
    });
    return response.data;
  } catch (error) {
    console.error('搜索药品失败:', error);
    throw error;
  }
};

/**
 * 获取公司简介数据
 * @returns {Promise} 返回API响应
 */
export const getAboutUs = async () => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.ABOUT_US);
    return response.data;
  } catch (error) {
    console.error('获取公司简介失败:', error);
    throw error;
  }
};

/**
 * 获取药品分类列表
 * @returns {Promise} 返回API响应
 */
export const getMedicineCategories = async () => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE_CATEGORY);
    return response.data;
  } catch (error) {
    console.error('获取药品分类失败:', error);
    throw error;
  }
};

/**
 * 获取药品详情
 * @param {number} id - 药品ID
 * @returns {Promise} 返回API响应
 */
export const getMedicineDetail = async (id) => {
  if (!id) {
    return {
      code: 0,
      msg: '参数错误',
      time: String(Math.floor(Date.now() / 1000))
    };
  }
  
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE_DETAIL, {
      params: { id }
    });
    return response.data;
  } catch (error) {
    console.error('获取药品详情失败:', error);
    throw error;
  }
};

/**
 * 获取推荐文章列表
 * @param {Object} params - 参数对象
 * @param {number} [params.page=1] - 页码
 * @param {number} [params.pagesize=10] - 每页数量
 * @returns {Promise} 返回API响应
 */
export const getArticles = async (params = {}) => {
  try {
    const axios = (await import('axios')).default;
    const defaultParams = {
      page: 1,
      pagesize: 10
    };
    
    const requestParams = { ...defaultParams, ...params };
    const response = await axios.get(API_URL.ARTICLE, { params: requestParams });
    return response.data;
  } catch (error) {
    console.error('获取文章列表失败:', error);
    throw error;
  }
};

/**
 * 获取底部信息
 * @returns {Promise} 返回API响应
 */
export const getFooterInfo = async () => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.FOOTER_INFO);
    return response.data;
  } catch (error) {
    console.error('获取底部信息失败:', error);
    throw error;
  }
};

/**
 * 用户注册
 * @param {string} username - 用户名
 * @param {string} password - 密码
 * @returns {Promise} 返回API响应
 */
export const registerUser = async (username, password) => {
  if (!username || !password) {
    return {
      code: 0,
      msg: '用户名和密码不能为空',
      time: String(Math.floor(Date.now() / 1000))
    };
  }
  
  try {
    const axios = (await import('axios')).default;
    const response = await axios.post(API_URL.USER_REGISTER, {
      username,
      password
    });
    return response.data;
  } catch (error) {
    console.error('注册失败:', error);
    throw error;
  }
};

/**
 * 用户登录
 * @param {string} account - 用户名/手机号/邮箱
 * @param {string} password - 密码
 * @returns {Promise} 返回API响应
 */
export const loginUser = async (account, password) => {
  if (!account || !password) {
    return {
      code: 0,
      msg: '账号和密码不能为空',
      time: String(Math.floor(Date.now() / 1000))
    };
  }
  
  try {
    const axios = (await import('axios')).default;
    const response = await axios.post(API_URL.USER_LOGIN, {
      account,
      password
    });
    return response.data;
  } catch (error) {
    console.error('登录失败:', error);
    throw error;
  }
};

/**
 * 获取用户信息（需要token）
 * @param {string} token - 用户token
 * @returns {Promise} 返回API响应
 */
export const getUserInfo = async (token) => {
  if (!token) {
    return {
      code: 0,
      msg: '缺少token',
      time: String(Math.floor(Date.now() / 1000))
    };
  }
  
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.USER_INFO, {
      headers: {
        TOKEN: token
      }
    });
    return response.data;
  } catch (error) {
    console.error('获取用户信息失败:', error);
    throw error;
  }
};

/**
 * 获取用户有权限的药品列表（需要token）
 * @param {string} token - 用户token
 * @param {number} [page=1] - 页码
 * @param {number} [pagesize=10] - 每页数量
 * @returns {Promise} 返回API响应
 */
export const getPermittedMedicines = async (token, page = 1, pagesize = 10) => {
  if (!token) {
    return {
      code: 0,
      msg: '缺少token',
      time: String(Math.floor(Date.now() / 1000))
    };
  }
  
  try {
    const axios = (await import('axios')).default;
    const url = API_URL.MEDICINE_PERMITTED;
    const requestConfig = {
      params: {
        page,
        pagesize
      },
      headers: {
        TOKEN: token
      }
    };
    
    const response = await axios.get(url, requestConfig);
    return response.data;
  } catch (error) {
    console.error('获取权限药品列表失败:', error);
    throw error;
  }
};

export default {
  BASE_URL,
  API,
  API_URL,
  getMedicines,
  getMedicinesByCategory,
  searchMedicineAPI,
  getAboutUs,
  getMedicineCategories,
  getMedicineDetail,
  getArticles,
  getFooterInfo,
  registerUser,
  loginUser,
  getUserInfo,
  getPermittedMedicines
}; 